import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../../services/usuario.service';
import { NgxSpinnerService } from "ngx-spinner";
import { take } from 'rxjs/operators';
import { MatDialogRef } from '@angular/material/dialog';
import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DOC_ORIENTATION, NgxImageCompressService } from 'ngx-image-compress';


@Component({
    selector: 'app-upload-imagem-dialog',
    templateUrl: './upload-imagem-dialog.html',
    styleUrls: ['./upload-imagem-dialog.scss', '../../../styles/estilo.padrao.scss']
})
export class UploadImagemDialogDialog implements OnInit {
    img64;
    uid;
    img
    imageChangedEvent: any = '';
    imageFile;
    croppedImage: any = '';
    croppedImageCopy: any = '';
    canvasRotation = 0;
    rotation = 0;
    scale = 1;
    showCropper = false;
    containWithinAspectRatio = false;
    transform: ImageTransform = {};

    constructor(
        private router: Router,
        private toastr: ToastrService,
        private usuarioService: UsuarioService,
        private spinner: NgxSpinnerService,
        private dialogRef: MatDialogRef<UploadImagemDialogDialog>,
        private imageCompress: NgxImageCompressService,
        @Inject(MAT_DIALOG_DATA) public data: { img64: any }
    ) {
        this.uid = localStorage.getItem('uid')
    }

    ngOnInit(): void {
        !this.data.img64 ? setTimeout(() => document.getElementById('file-input').click(), 50) : this.imageFile = this.data.img64;
    }

    cortar() {
        this.dialogRef.close(this.croppedImage);
    }

    fileChangeEvent(event: any): void {
        this.imageChangedEvent = event;
    }

    imageCropped(event: ImageCroppedEvent) {

        this.croppedImageCopy = event.base64;

        this.imageCompress.compressFile(this.croppedImageCopy, -1, 50, 50).then(
            result => {
                console.warn('Size in bytes was:', this.imageCompress.byteCount(event.base64));

                console.warn('Size in bytes is now:', this.imageCompress.byteCount(result));

                this.croppedImage = result;
            }
        )
    }

    imageLoaded(image: any) {
        //image loaded
    }


    cropperReady() {
        // cropper ready
    }
    loadImageFailed() {
        window.alert("Erro ao carregar imagem, por favor tente novamente!");
        this.dialogRef.close();
    }

    onZoom(e) {
        this.scale = e.value;
        this.transform = {
            ...this.transform,
            scale: this.scale
        };
    }

    resetImage() {
        this.scale = 1;
        this.rotation = 0;
        this.canvasRotation = 0;
        this.transform = {};
    }

    rotateLeft() {
        this.canvasRotation--;
        this.flipAfterRotate();
    }

    rotateRight() {
        this.canvasRotation++;
        this.flipAfterRotate();
    }

    flipHorizontal() {
        this.transform = {
            ...this.transform,
            flipH: !this.transform.flipH
        };
    }

    flipVertical() {
        this.transform = {
            ...this.transform,
            flipV: !this.transform.flipV
        };
    }

    private flipAfterRotate() {
        const flippedH = this.transform.flipH;
        const flippedV = this.transform.flipV;
        this.transform = {
            ...this.transform,
            flipH: flippedV,
            flipV: flippedH
        };
    }


    cancelar() {
        this.dialogRef.close();
    }

}
